import { DetailsListLayoutMode, ICommandBarItemProps, Icon, TooltipHost } from "@fluentui/react";
import { UseCatalogoTable } from "./UseCatalogoTable"
import { useBoolean } from "@fluentui/react-hooks";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { ICatalogoInseguroDTO } from "../../../../Interfaces/hazard/IHazard";
import themeBase from "../../../../utils/theme/themeBase";
import { useEffect, useState } from "react";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import { PanelInsertarCatalogo } from "./nuevoCatalogo/PanelInsertarCatalogo";
import { PanelEditarCatalogo } from "./editarCatalogo/PanelEditarCatalogo";
import { PanelOcultoCatalogo } from "./ocultoCatalogo/PanelOcultoCatalogo";

export interface ICatalogoTable{
    esCondicion:boolean
}
export const CatalogoTable=(props:ICatalogoTable)=>{
    const { items, filter, setFilter, loading, pagination, onChangeSearch, getCatalogos, 
    handleResetUpdate, onChangeTake, _onkeyUpSearchTable } = UseCatalogoTable(props)
    const [isOpenEditar, { setTrue: openPanelEditar, setFalse: closePanelEditar }] = useBoolean(false);
    const [isOpenNuevo, { setTrue: openPanelNuevo ,setFalse: closePanelNuevo }] = useBoolean(false)
    const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
    const [item, setItem] = useState<ICatalogoInseguroDTO>({
        catalogoInseguroId: "",
        nombreCatalogoInseguro: "",
        codigoCatalogoInseguro: "",
        esOculto:false
    })
    useEffect(()=>{
        handleResetUpdate()
    },[props.esCondicion])

    const buttonLeft: ICommandBarItemProps[] = [
        {
          ...IconHelper.ICON_ADD_TABLE,
          text: "Nuevo",
          onClick: openPanelNuevo,
       },
       {
         ...IconHelper.ICON_RELOAD,
         text: "Actualizar",
         onClick: () => {
           handleResetUpdate()
         },
       }
     ];
     const _columns = [
        {
          key: "nombreCatalogoInseguro",
          name: "Catalogo",
          fieldName: "nombreCatalogoInseguro",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          key: "codigoCatalogoInseguro",
          name: "Codigo",
          fieldName: "codigoCatalogoInseguro",
          minWidth: 100,
          maxWidth: 300,
        },
        {
            key: "opciones",
            name: "Opciones",
            minWidth: 100,
            maxWidth: 300,
            onRender: (item: ICatalogoInseguroDTO) => renderOpciones(item)
          }
         ]
         function renderOpciones(item: ICatalogoInseguroDTO) {
            return (
                <>
                  <TooltipHost content={"Editar"}>
                    <Icon
                      iconName="Edit"
                      className={themeBase.classNamesIcon.iconFont}
                      style={{ cursor: "pointer", color: "#0078d3" }}
                      onClick={() => {
                        setItem(item)
                        openPanelEditar()
                      }}
                    />
                  </TooltipHost>
                  {item.esOculto ? (<TooltipHost content={"Integrar"}>
                     <Icon
                       iconName="Add"
                       className={themeBase.classNamesIcon.iconFont}
                       style={{ cursor: "pointer", color: "#0078d3" }}
                       onClick={() => {
                         setItem(item)
                         openPanelEliminar()
                       }}
                     />
                  </TooltipHost>):(
                     <TooltipHost content={"Ocultar"}>
                     <Icon
                       iconName="Delete"
                       className={themeBase.classNamesIcon.iconFont}
                       style={{ cursor: "pointer", color: "#0078d3" }}
                       onClick={() => {
                         setItem(item)
                         openPanelEliminar()
                       }}
                     />
                   </TooltipHost>
                  )}
                 
                </>
              );
        }
        return(
        <>
        <CabeceraTable
        Titulo={props.esCondicion?"Catalogo de condiciones Inseguras":"Catalogo de actos inseguros"}
        SubTitulo={props.esCondicion?"Gestión de condiciones Inseguras":"Gestión de actos inseguros"}
        onKeyUp={_onkeyUpSearchTable}
        />
        <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
        />
        
        <PanelInsertarCatalogo esCondicion={props.esCondicion} isOpen={isOpenNuevo} 
        onDismiss={closePanelNuevo} reload={handleResetUpdate}/>
        <PanelEditarCatalogo item={item} isOpen={isOpenEditar} onDismiss={ closePanelEditar}
        reload={handleResetUpdate}/>
        <PanelOcultoCatalogo item={item} isOpen={isOpenEliminar} onDismiss={closePanelEliminar} reload={handleResetUpdate}/>
        </>
        )

}